import React from "react";
import {createUseStyles} from "react-jss";

const useStyle = createUseStyles(({colors}) => ({
    alternative: {
        display: "flex",
        alignItems: "center",
        border: ({whiteBorder}) => `2px solid ${whiteBorder ? colors.white : colors.black}`,
        borderRadius: "999px",
        padding: "11px 24px 13px 20px",
        margin: "8px 0",
        minHeight: "44px",
        width: "100%",
        background: "transparent",
        color: "inherit",
        fontFamily: "inherit",
        fontSize: "inherit",
        textAlign: "left",
        cursor: "pointer",
        boxSizing: "border-box",
        outline: "none",
        "&:focus-visible": {
            outline: "2px solid #4484F1",
            outlineOffset: "2px",
        },
        "&:disabled": {
            cursor: "default",
        },
    },
}));

export const AlternativeContainer = ({
    onClick = null,
    variantClass = "",
    whiteBorder = false,
    ariaChecked = false,
    disabled = false,
    children,
}) => {
    const classes = useStyle({
        whiteBorder: whiteBorder,
    });

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
            e.preventDefault();
            if (!disabled && onClick) {
                onClick(e);
            }
        }
    };

    return (
        <button
            type="button"
            role="radio"
            aria-checked={ariaChecked ? "true" : "false"}
            aria-disabled={disabled ? "true" : "false"}
            disabled={disabled}
            className={`${classes.alternative} ${variantClass}`}
            onClick={disabled ? undefined : onClick}
            onKeyDown={handleKeyDown}
        >
            {children}
        </button>
    );
};